export default __webpack_public_path__ + "static/media/TL08.267a3128.mp3";